import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Customer } from './model/customer';
import { CustomernameService } from './service/customername.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customername',
  templateUrl: './customername.component.html',
  styleUrls: ['./customername.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomernameComponent implements OnInit, OnChanges {
  @Output() customer: Customer;
  @Input() customerId: string;
  @Input() link: boolean;
  @Input() pretext: boolean;
  constructor(
    private cnsrv: CustomernameService,
    private datastore: DatastoreService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.customer = new Customer;
    this.customer.title = '';
    if (this.customerId) {
      //get from datastore
      if (this.datastore.customers.getValue().length > 0) {
        this.customer = this.datastore.customers.getValue().find(c => c.customerId.split('_')[0] === this.customerId.split('_')[0]);
        if (!this.customer) {
          this.customer = new Customer;
          this.customer.title = 'No customer';
        }
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customerId && changes.customerId.currentValue) {
      //get from datastore
      if (this.datastore.customers.getValue().length > 0) {
        this.customer = this.datastore.customers.getValue().find(c => c.customerId.split('_')[0] === changes.customerId.currentValue.split('_')[0]);
        if (!this.customer) {
          this.customer = new Customer;
          this.customer.title = 'No customer';
        }
      }
    }
  }
  goToCustomer() {
    const customerId = this.customer?.customerId || this.customerId;
    if (!customerId) {
      return;
    }
    this.router.navigate(['/customer', customerId]);
  }
}
